import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { membersQueryOptions, TeamPage } from '@/features/team';

export const Route = createFileRoute('/_authed/_active/org/team')({
  staticData: { crumb: 'common:nav.team', tours: ['org.team'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'staff.read');
  },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...membersQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: TeamPage,
});
